/* src/app/app.component.scss */
.app-split-pane {
  --side-width: 264px;
  --side-max-width: 280px;
  --side-min-width: 240px;
}
ion-menu {
  --background: var(--ion-background-color, #ffffff);
  --width: 264px;
  --max-width: 280px;
  --min-width: 240px;
}
ion-split-pane {
  --border: none;
}
/*# sourceMappingURL=app.component.css.map */
